import {isDevMode} from '@angular/core';
import {environment, EnvironmentName} from '@shared-types';

export function isDevelopmentEnv(): boolean {
	return isDevMode() || environment.name.startsWith(EnvironmentName.Dev);
}
